export const id_ct_contentInfo = "1.2.840.113549.1.9.16.1.6";
export const id_data = "1.2.840.113549.1.7.1";
export const id_signedData = "1.2.840.113549.1.7.2";
export const id_envelopedData = "1.2.840.113549.1.7.3";
export const id_digestedData = "1.2.840.113549.1.7.5";
export const id_encryptedData = "1.2.840.113549.1.7.6";
export const id_authData = "1.2.840.113549.1.9.16.1.2";
